// buttonVisibility.js
/**
 * ✅ ฟังก์ชันตรวจสอบว่าแสดงปุ่ม Approve ได้หรือไม่
 * - อนุญาตเฉพาะผู้ที่มี level > 1
 * - ต้องเป็น Quotation ที่อยู่ในสถานะ "Pending"
 */
const getApprovalFlow = (approvalHierarchy) =>
  approvalHierarchy?.[0]?.approvalHierarchy || [];

const normalizeEmail = (value) => String(value || "").trim().toLowerCase();

const isApprovedStep = (entry) => entry?.status === "Approved";

export const isCurrentApprovalTurn = (userLevel, approvalHierarchy) => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const email = normalizeEmail(user.username);
  const level = Number(userLevel || user.level || 0);

  const flow = getApprovalFlow(approvalHierarchy);
  const currentStep = flow.find(
    (entry) =>
      normalizeEmail(entry.approver) === email &&
      entry.status === "Pending" &&
      Number(entry.level) === level
  );

  if (!currentStep) return false;

  return flow
    .filter((entry) => Number(entry.level) < Number(currentStep.level))
    .every(isApprovedStep);
};

export const canApprove = (approvalStatus, userLevel, approvalHierarchy) => {
  // if (user.role === "admin") {
  //   return approvalStatus === "Pending";
  // }

  return (
    approvalStatus === "Pending" &&
    isCurrentApprovalTurn(userLevel, approvalHierarchy)
  );
};

/**
 * ✅ ฟังก์ชันตรวจสอบว่าแสดงปุ่ม Reject ได้หรือไม่
 * - อนุญาตเฉพาะผู้ที่มี level > 1
 * - ต้องเป็น Quotation ที่อยู่ในสถานะ "Pending"
 */

export const canReject = (approvalStatus, userLevel, approvalHierarchy) => {
  // if (user.role === "admin") {
  //   return approvalStatus === "Pending";
  // }

  return (
    approvalStatus === "Pending" &&
    isCurrentApprovalTurn(userLevel, approvalHierarchy)
  );
};

/**
 * ✅ ฟังก์ชันตรวจสอบว่าแสดงปุ่ม Cancel ได้หรือไม่
 * - อนุญาตเฉพาะ Level >= 2 เท่านั้น
 * - ต้องเป็น Quotation ที่ไม่ใช่ "Approved"
 */
export const canCancel = (approvalStatus, userLevel, approvalHierarchy) => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const canCancelStatus =
    approvalStatus !== "Approved" && approvalStatus !== "Canceled";

  if (user.role === "admin") {
    return canCancelStatus;
  }

  return (
    canCancelStatus &&
    isCurrentApprovalTurn(userLevel, approvalHierarchy)
  );
};
/**
 * ✅ ฟังก์ชันตรวจสอบว่าแสดงปุ่ม Edit และ Delete ได้หรือไม่
 * - ซ่อนปุ่ม Edit และ Delete ถ้า approvalStatus เป็น "Canceled" หรือ "Approved"
 */
export const canEditDelete = (approvalStatus) => {
  return approvalStatus !== "Canceled" && approvalStatus !== "Approved";
};

export const isOwnQuotation = (quotation = {}, user = null) => {
  const currentUser =
    user || JSON.parse(localStorage.getItem("user")) || {};

  return (
    normalizeEmail(quotation.createdByUser) ===
    normalizeEmail(currentUser.username)
  );
};

export const isLevelOneViewingOtherQuotation = (
  quotation = {},
  user = null
) => {
  const currentUser =
    user || JSON.parse(localStorage.getItem("user")) || {};

  return (
    Number(currentUser.level || 0) === 1 && !isOwnQuotation(quotation, currentUser)
  );
};
/**
 * ✅ ฟังก์ชันตรวจสอบว่าแสดงปุ่มได้เฉพาะ admin เท่านั้น
 * - ตรวจจาก user.role ใน localStorage
 */
// ✅ ฟังก์ชันตรวจสอบว่าเป็น admin หรือไม่
export const isAdmin = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  return user.role === "admin";
};

const normalize = (value) => String(value || "").trim().toLowerCase();
const profileOnlyGroups = ["creative", "vertix", "socialadmin", "strategic"];

export const isCreativeUserRecord = (user = {}) => {
  return [user.department, user.team, user.teamGroup].some(
    (value) => profileOnlyGroups.includes(normalize(value))
  );
};

export const isCreativeUser = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  return isCreativeUserRecord(user);
};

export const getDefaultHomePath = (user = {}) =>
  isCreativeUserRecord(user) ? "/profile" : "/";

export const canAccessQtMenus = () => !isCreativeUser();

export const isTravelTollOnlyUser = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  return Number(user.level || 0) >= 3;
};

export const canCreateTravelExpense = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const level = Number(user.level || 0);
  return level > 0 && level < 5;
};

export const canApproveTravelExpense = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const level = Number(user.level || 0);
  return user.role === "admin" || (level >= 2 && level <= 5);
};


/**
 * ✅ ฟังก์ชันตรวจสอบสิทธิ์การเห็น ReportChart ใน Dashboard
 * - แสดงได้เฉพาะผู้ที่เป็น admin หรืออยู่แผนก Management และมี level >= 5
 * - ถ้าไม่เข้าเงื่อนไข → ซ่อน
 */
export const canViewReportChart = () => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const { role, department } = user;
  const level = Number(user.level || 0);

  // ✅ admin เห็นได้เสมอ
  if (role === "admin") return true;

  // ✅ ผู้ใช้ทั่วไป ต้องอยู่แผนก Management และมี level >= 5
  return department === "Management" && level >= 5;
};
